import React, { useEffect } from 'react';
import { MapPin, Clock, Phone, Navigation } from 'lucide-react';
import { showroomDetails } from '../mockData';

const LocationLeadGen = () => {
  useEffect(() => {
    const d = document;
    const w = "https://tally.so/widgets/embed.js";
    const v = () => {
      if (typeof window.Tally !== 'undefined') {
        window.Tally.loadEmbeds();
      } else {
        d.querySelectorAll("iframe[data-tally-src]:not([src])").forEach((e) => {
          e.src = e.dataset.tallySrc;
        });
      }
    };
    if (typeof window.Tally !== 'undefined') {
      v();
    } else if (!d.querySelector(`script[src="${w}"]`)) {
      const s = d.createElement("script");
      s.src = w;
      s.onload = v;
      s.onerror = v;
      d.body.appendChild(s);
    } else {
      v();
    }
  }, []);

  const openInMaps = () => {
    window.open('https://www.google.com/maps/place/18%C2%B035\'37.3%22N+73%C2%B047\'58.9%22E/@18.593703,73.7997242,17z', '_blank');
  };

  return (
    <section id="location" className="location-section">
      <div className="section-container">
        <div className="location-grid">
          <div className="location-info-container">
            <h2 className="section-title">Visit Our Showroom</h2>
            <p className="section-subtitle">
              Experience the gear in person. Our experts are ready to help you find your perfect fit.
            </p>

            <div className="location-details">
              <div className="location-detail-item">
                <MapPin className="location-icon" />
                <div>
                  <h4 className="detail-label">Address</h4>
                  <p className="detail-text">{showroomDetails.address}</p>
                </div>
              </div>

              <div className="location-detail-item">
                <Clock className="location-icon" />
                <div>
                  <h4 className="detail-label">Operating Hours</h4>
                  <p className="detail-text">{showroomDetails.hours} • {showroomDetails.daysOpen}</p>
                </div>
              </div>

              <div className="location-detail-item">
                <Phone className="location-icon" />
                <div>
                  <h4 className="detail-label">Contact</h4>
                  <p className="detail-text">{showroomDetails.phone}</p>
                </div>
              </div>
            </div>

            <button onClick={openInMaps} className="btn-primary direction-button">
              <Navigation size={20} />
              Get Directions
            </button>
          </div>

          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3781.4267847856247!2d73.79752427515!3d18.593703182526!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTjCsDM1JzM3LjMiTiA3M8KwNDcnNTguOSJF!5e0!3m2!1sen!2sin!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0, filter: 'invert(90%) hue-rotate(180deg)' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Showroom Location"
            ></iframe>
          </div>
        </div>
      </div>

      <div id="lead-gen" className="lead-gen-section">
        <div className="lead-gen-container">
          <div className="lead-gen-content">
            <h2 className="lead-gen-title">Join the Inner Circle</h2>
            <p className="lead-gen-subtitle">
              Get notified the second new gear hits our shelves. Plus exclusive early-bird discounts.
            </p>
          </div>

          <div className="lead-gen-form-container">
            <iframe
              data-tally-src="https://tally.so/embed/zxWKj0?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
              loading="lazy"
              width="100%"
              height="200"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              title="Join our Community!"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationLeadGen;
